import gql from 'graphql-tag';

const CLUB_TRANSFER_REQUEST_RESPOND_AS_MEMBER= gql`
mutation clubTransferRequestRespondAsMember($id: ID!, $memberId: ID!, $result:ResponseResult ) {
  clubTransferRequestRespondAsMember(id: $id, memberId: $memberId, result: $result) {
    id
    bid
  }
}
`;

export default CLUB_TRANSFER_REQUEST_RESPOND_AS_MEMBER;
